import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { workOrderStatusOptions } from "./types";

export const fields: FilterFieldConfig[] = [
    { key: "labNumber", label: "Lab Number", type: "text", default: "" },
    { key: "labNumberDate", label: "Lab Number Date", type: "text", default: "" },
    { key: "organizationId", label: "Organization Name", type: "asyncSelect", default: "",
        fileName: "common/searchOrganization.php",
        placeholder: "Search organization…",
        isMulti: false,
    },
    { key: "contactId", label: "Contact Name", type: "asyncSelect", default: "",
        fileName: "common/searchContact.php",
        placeholder: "Search contact…",
        isMulti: false,
    },
    { key: "poNumber", label: "PO Number", type: "text", default: "" },
    { key: "quoteNumber", label: "Quote Number", type: "text", default: "" },
    { key: "deadline", label: "Deadline", type: "range", default: "", inputType: "date" },
    { key: "workOrderDate", label: "Work Order Date",  type: "range", default: "", inputType: "date" },
    { key: "partsReceivedDate", label: "Parts Received Date", type: "range", default: "", inputType: "date" },
    { key: "receivedById", label: "Received By", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },

    { key: "techs", label: "Technician", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },
    { key: "notes", label: "Notes", type: "text", default: "" },
    { key: "holdReason", label: "Hold Reason", type: "text", default: "" },
    { key: "workOrderStatus", label: "Work Order Status", type: "select", default: "",
        options: [
            { value: "", label: "All" },
            ...workOrderStatusOptions.map(value => ({ value, label: value }))
        ],
    },
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no",
        options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function WorkOrderFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
